import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/store/appState';
import { fetchPermissionsRequests } from '@shared/store/action/common.action';
import { AuthService } from '@auth/services/auth.service';
import { ACCESS_TOKEN_KEY } from '@shared/utils/constants';

@Component({
    standalone: true,
    // tslint:disable-next-line:component-selector
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [RouterModule],
})
export class AppComponent implements OnInit {
    constructor(
        private store: Store<AppState>,
        private authService: AuthService
    ) {}

    ngOnInit() {
        if (this.authService.hasValidToken()) {
            this.store.dispatch(
                fetchPermissionsRequests({
                    payload: this.authService.currentUserId,
                })
            );
        } else {
            localStorage.removeItem(ACCESS_TOKEN_KEY);
            this.authService.login(location.pathname);
        }
    }
}
